import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-9 gap-[10px]" }
const _hoisted_2 = { class: "font-semibold text-xl leading-[24px]" }
const _hoisted_3 = { class: "cursor-pointer text-xl leading-[24px]" }
const _hoisted_4 = { class: "max-w-96 text-left" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "max-w-96 text-left" }
const _hoisted_7 = { class: "cursor-pointer text-base leading-[20px] min-w-[40px]" }
const _hoisted_8 = { class: "max-w-96" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "cursor-pointer text-base leading-[20px]" }
const _hoisted_11 = { class: "max-w-96" }
const _hoisted_12 = { class: "text-left" }


import AppTooltip from "@/components/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualsLuck',
  props: {
    years: {},
    palaces: {}
  },
  setup(__props: any) {

const props = __props;

const elementNames: Record<string, string> = {
  木: "wood",
  火: "fire",
  土: "earth",
  金: "metal",
  水: "water",
};

function trendClass(trend: string): string {
  if (trend === "unfavorable") {
    return "border-[#f5c6cb]";
  }
  if (trend === "favorable") {
    return "border-[#c3e6cb]";
  }
  return "border-[#d6d8db]";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.years.slice(0, 27), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["flex md:flex-col gap-4 py-2 border-2 rounded-lg flex-grow max-md:px-4 items-center max-md:justify-between bg-white", trendClass(item.trend)])
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(item.year), 1),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(item.year_pillar), 1)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.tips.pillar), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("img", {
              src: 
              require(`@/assets/calculators/bazi/${
                elementNames[item.element]
              }.png`)
            ,
              alt: item.element,
              class: "element-img cursor-pointer mx-auto size-10"
            }, null, 8, _hoisted_5)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.tips.element), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.stage), 1)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", null, _toDisplayString(item.tips.stage_label), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.tips.stage), 1)
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(AppTooltip, null, {
          trigger: _withCtx(() => [
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.palaces[item.hit_palace]["hieroglyph"]), 1)
          ]),
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h5", null, _toDisplayString(item.tips.palace_label), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.tips.palace_description), 1)
            ])
          ]),
          _: 2
        }, 1024)
      ], 2))
    }), 128))
  ]))
}
}

})